<div
	class="bg-peps-dark-600 flex flex-row items-center gap-4 p-4 min-h-[144px] hover:-translate-y-2 transition-transform duration-300"
	[ngClass]="{'border-2 border-peps-gold': isUserHasCompleted}"
>
	@if(hasBadgeReward(challenge!)) {
		<img
			[src]="getRewardImage(challenge!, isUserHasCompleted)"
            class="size-14"
		>
	}
	<div class="flex flex-col gap-2">
		<span class="uppercase text-lg">{{ challenge!.translations[translateDynamicService.getLang()].name}}</span>
		<p class="font-notosans">
			{{ challenge!.translations[translateDynamicService.getLang()].description}}
		</p>
		<p class="font-notosans text-sm text-peps-dark-200/80" [innerHTML]="challenge! | challengeRewards"></p>

	</div>
</div>
